import moment from "moment";
import {Card, Col, Divider, Row, Typography} from "antd";
import CountdownTimer from "./countdown-timer";
import React from "react";
const {Title} = Typography;

const ChallengeCountdown = ({competition}) => {
    const today = moment(); // Assuming today is the 3rd day of challenge
    const startDate = competition.begin_date ? moment(competition.begin_date) : moment("2025-01-01");
    const endDate = competition.end_date ? moment(competition.end_date) : moment("2025-02-28");
    const isChallengedEnd = today.isAfter(endDate); // Returns true if the challenge has ended
    return (
        <Card>
            <Divider orientation="left">
                <Title style={{margin: 0}} level={4}>Väljakutse lõpuni</Title>
            </Divider>

            <Row type="flex" align="middle" gutter={[20, 20]}>
                <Col span={24}>
                    <CountdownTimer isChallengedEnd={isChallengedEnd} endDate={endDate}/>
                </Col>
            </Row>
        </Card>
    )
}

export default ChallengeCountdown